import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/img/jobtoken/coins-onboarding.png")